export default __webpack_public_path__ + "static/media/supervision2_horizontal_nobg_v2.740ee06e.png";